import { createContext } from 'react';

export type TransferFundCtx = {
  showTransferFundErrorAlert: boolean;
  transferFundError: string;
  showTransferFundConfirmAlert?: boolean;
};

const TransferFundDialogueContext = createContext<TransferFundCtx>({
  showTransferFundErrorAlert: false,
  transferFundError: '',
  showTransferFundConfirmAlert: false,
});

export default TransferFundDialogueContext;